import React from 'react';
import { useTranslation } from 'react-i18next';
import avatarMen from '../../../assets/images/avatar-men.png';
import avatarWomen from '../../../assets/images/avatar-women.png';
import { AvatarType } from '../types';

interface ProfileStep2Props {
	selectedAvatar: AvatarType;
	onAvatarSelect: (avatar: AvatarType) => void;
}

const ProfileStep2: React.FC<ProfileStep2Props> = ({ selectedAvatar, onAvatarSelect }) => {
	const { t } = useTranslation();

	return (
		<div className="row text-profile__row">
			<div className="col-12 col-lg-6 mt-1">
				<div className="avatar-img">
					<img
						src={avatarWomen}
						alt="Avatar Women"
						className={`avatar-img-item ${selectedAvatar === 'women' ? 'avatar-img-item-active' : ''}`}
						onClick={() => onAvatarSelect('women')}
					/>
					<img
						src={avatarMen}
						alt="Avatar Men"
						className={`avatar-img-item ${selectedAvatar === 'men' ? 'avatar-img-item-active' : ''}`}
						onClick={() => onAvatarSelect('men')}
					/>
				</div>
			</div>
		</div>
	);
};

export default ProfileStep2;
